angular.module('aprima-legacy-common').factory('CurrentUser', ['LocalStorageRepository', 'TransitionManager', 'Bridge', 'LogOffService', '$state', 'LogInService', '$rootScope',
    function (LocalStorageRepository, TransitionManager, Bridge, LogOffService, $state, LogInService, $rootScope) {
    'use strict';

    var previousTransition;

    $rootScope.$on('TransitionActivated', function(evt, transition){
        previousTransition = transition;
    });

    Bridge.on('force-logoff-user', null, function(){
        LogInService.setRedirect(previousTransition);

        LogOffService.logoff().then(function () {
            TransitionManager.transition({appRoute: 'login', opts: {replaceCurrentState: true}});
        });
    });

    return {

        isAuthenticated: function () {
            var jwt = LocalStorageRepository.getJsonWebToken();
            return !!jwt;
        },

        get: function () {
            return {
                name: LocalStorageRepository.getUserName(),
                fullName: LocalStorageRepository.getUserFullName(),
                userId: LocalStorageRepository.getUserID(),
                token: LocalStorageRepository.getJsonWebToken(),
                clientId: LocalStorageRepository.getClientID(),
                clientURL: LocalStorageRepository.getClientURL(),
                deviceId: LocalStorageRepository.getDeviceId(),
                permissions: LocalStorageRepository.getUserPermissions()
            };
        }
    };
}]);
